import { Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { Sector } from '../../context/SectorContext';

interface SectorTableProps {
  sectors: Sector[];
  isLoading: boolean;
  onView: (sector: Sector) => void;
}

export function SectorTable({ sectors, isLoading, onView }: SectorTableProps) {
  const theme = useTheme();

  const columns = [
    { field: 'name', headerName: 'Nome', flex: 1 },
    { field: 'description', headerName: 'Descrição', flex: 1 },
    {
      field: 'tenant',
      headerName: 'Empresa',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value?.name || '-'}
        </Typography>
      )
    },
  ];

  return (
    <DatabaseTable
      rows={sectors}
      columns={columns}
      loading={isLoading}
      onView={onView}
      hideDelete
      hideEdit
    />
  );
}